import { useQuery } from '@tanstack/react-query'
import { warRoomClient } from '../api/warRoomClient'
import { WAR_ROOM_QUERY_KEYS } from '../api/queryClient'
import type { Team } from '../types/session.types'

export function useTeams(sessionId: string) {
  return useQuery({
    queryKey: WAR_ROOM_QUERY_KEYS.teams(sessionId),
    queryFn: () =>
      warRoomClient
        .get(`sessions/${sessionId}/teams`)
        .json<{ data: Team[] }>()
        .then((r) => r.data),
    staleTime: 30_000,
    enabled: !!sessionId,
  })
}
